import {
  emailToSendNotificationsSchema,
  emailToSendNotificationsUI,
  internationalPhoneSchema,
  internationalPhoneUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validateTelephoneInput } from 'platform/forms-system/src/js/validation';
import {
  claimantFields,
  claimantInformationText,
} from '../definitions/constants';
import TelephoneFieldNoInternalErrors from '../components/TelephoneFieldNoInternalErrors';

const primaryPhoneValidations = [
  (errors, value) => {
    const isUSPhone = value?.countryCode === 'US';
    const errorMessage = isUSPhone
      ? claimantInformationText.usPhoneRequiredError
      : claimantInformationText.otherCountryPhoneRequiredError;

    if (!value?.contact || String(value.contact).trim() === '') {
      errors.addError(errorMessage);
      return;
    }

    validateTelephoneInput(errors, {
      ...value,
      error: errorMessage,
      required: true,
      touched: true,
    });
  },
];

export default {
  uiSchema: {
    'ui:options': { preserveHiddenData: true , forceDivWrapper: true},
    ...titleUI(
      claimantInformationText.pageTitleCont,
      claimantInformationText.pageDescriptionCont,
    ),
    [claimantFields.parentObject]: {
      [claimantFields.phone]: {
        ...internationalPhoneUI({
          title: claimantInformationText.phoneTitle,
          hint: '',
        }),
        'ui:webComponentField': TelephoneFieldNoInternalErrors,
        'ui:required': () => true,
        'ui:errorMessages': {
          required: claimantInformationText.usPhoneRequiredError,
        },
        'ui:validations': primaryPhoneValidations,
      },
      [claimantFields.email]: {
        ...emailToSendNotificationsUI({
          title: claimantInformationText.emailTitle,
          hint: claimantInformationText.emailHint,
          errorMessages: {
            required: claimantInformationText.emailError,
            format: claimantInformationText.emailError,
          },
        }),
        'ui:required': () => true,
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      [claimantFields.parentObject]: {
        type: 'object',
        properties: {
          [claimantFields.phone]: internationalPhoneSchema({
            required: true,
          }),
          [claimantFields.email]: emailToSendNotificationsSchema,
        },
        required: [claimantFields.phone, claimantFields.email],
      },
    },
  },
};
